import { combineReducers } from 'redux';

import aggregationReducer from '../aggregationMenu/store/reducer';
import deferredRollforwardReducer from '../viewDeferredRollforwardPage/store/reducer';
import taxLifecycleReducer from '../viewTaxLifecyclePage/store/reducer';
import taxReserveReducer from '../viewTaxReservesPage/store/reducer';
import accountBalancesReducer from '../viewAccountBalancesPage/store/reducer';
import rateChangeWorkpaperReducer from '../rateChangeWorkpaperPage/store/reducer';
import balanceSheetManagementReducer from './bsm.reducer';


export default combineReducers({
  shared: balanceSheetManagementReducer,
  accountBalances: accountBalancesReducer,
  aggregation: aggregationReducer,
  deferredRollforward: deferredRollforwardReducer,
  taxLifecycle: taxLifecycleReducer,
  taxReserve: taxReserveReducer,
  rateChangeWorkpaper: rateChangeWorkpaperReducer,
});
